<section
    [id]="id()"
    class="relative w-full h-full"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [attr.data-uitype]="'graph-legend'"
        class="flex justify-between items-center pl-[80px] py-4 text-dat-grey-200"
    >
        <h3 class="font-headline-5 sm:text-xs">Van Rates</h3>
        <div class="flex items-center pr-[20px]">
            <span
                class="rounded-full h-6 w-6 bg-[#FFBF00] inline-block mx-4 sm:h-2 sm:w-2 sm:mx-2"
            ></span>
            <label class="mr-4 font-headline-5 sm:text-xs"> Spot Rates</label>
            <span
                class="rounded-full h-6 w-6 mx-4 bg-[#EC5A24] inline-block mr-2 sm:h-2 sm:w-2 sm:mx-2"
            ></span>
            <label class="font-headline-5 mr-4 sm:text-xs">Contract Rates</label>
        </div>
    </section>
    <section  class="flex">
        <div
            [attr.data-testid]="id() + '-graph'"
            [attr.data-styletarget]="id() + '-graph'"
            [attr.data-uitype]="'graph'"
            class="w-5/6 h-full sm:!h-[300px]"
            [ngClass]="{'w-5/6': upsellEnabled(), 'w-full': !upsellEnabled()}"
            #graph
        ></div>
        @if(upsellEnabled()){
            <div class="bg-black content-center w-1/6 text-white">
                <iq-trendlines-graph-rates-forecast-banner>
                </iq-trendlines-graph-rates-forecast-banner>
         </div>
        }
    </section>
</section>
<div [attr.data-json-info]="'rates-van'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />
